'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _translateDOMPositionXY = require('dom-lib/lib/transition/translateDOMPositionXY');

var translateDOMPositionXY = (0, _translateDOMPositionXY.getTranslateDOMPositionXY)({
  enable3DTransform: true
});
exports.default = translateDOMPositionXY;